import { PencilIcon } from "@heroicons/react/outline";

import { useNode } from "../../../node-context";
import NodeTypeIcon from "../NodeTypeIcon";

import blocks, { rawBlockTypeToBlockType } from "@/components/PowerBlock/Blocks";
import { useWorkflow } from "@/components/Workflows/WorkflowCanvas/workflow-context";
import { BlockType } from "@/components/Workflows/types";
import { BasicTooltip } from "@/components/ui/Tooltip";

const NodeTypeLabel: React.FC<{
  type: BlockType;
  iconBackgroundColor: string;
  iconTextColor: string;
}> = ({ type, iconBackgroundColor, iconTextColor }) => {
  const workflow = useWorkflow();
  const node = useNode();
  const isSelected = workflow.isNodeSelected(node?.id || "");

  const blockType = rawBlockTypeToBlockType(type);

  const displayLabel = blockType;
  const tooltipContent = blocks[blockType]?.short_description;

  const body = (
    <span className="flex flex-row items-center gap-x-1">
      {displayLabel}
      <NodeTypeIcon type={type} backgroundColor={iconBackgroundColor} textColor={iconTextColor} />
    </span>
  );

  const renderContent = () => {
    if (isSelected && !workflow.readonly) {
      return (
        <>
          Editing...
          <div
            className={`rounded-full ${iconBackgroundColor} p-1 ${iconTextColor} transition-all duration-300 ease-in-out`}
          >
            <PencilIcon className="h-4 w-4" />
          </div>
        </>
      );
    }

    if (tooltipContent) {
      return <BasicTooltip content={tooltipContent}>{body}</BasicTooltip>;
    }

    return body;
  };

  return type ? (
    <span className="text-md flex flex-row items-center gap-x-1 font-medium text-gray-500">
      {renderContent()}
    </span>
  ) : null;
};

export default NodeTypeLabel;
